import { render, staticRenderFns } from "./formName.vue?vue&type=template&id=9a2c4140&scoped=true"
import script from "./formName.vue?vue&type=script&lang=js"
export * from "./formName.vue?vue&type=script&lang=js"
import style0 from "./formName.vue?vue&type=style&index=0&id=9a2c4140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2c4140",
  null
  
)

export default component.exports